import { Box, Button, Flex, Menu, Table, TextInput } from "@mantine/core";
import { IconCheck, IconSearch } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";

const ModalsSyncRockBottomPriceList = ({ onSuccess }: { onSuccess: any }) => {
  const [opened, setOpened] = useState(false);

  const [searchItem, setSearchItem] = useState<string>("");
  const [dataProductMap, setDataProductMap] = useState<any[]>([]);
  const [dataProductView, setDataProductView] = useState<any[]>([]);

  const handleDeleteItem = (itemCode: string) => {
    const dataDelete = dataProductView.filter(
      (item) => item.itemCode !== itemCode
    );

    setDataProductView(dataDelete);
  };

  const fetchDataProduct = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblItem/get-list?Skip=0&Take=20&KeySearch=${searchItem}`
    );

    if (res && res.success) {
      const result = res.data;
      setDataProductMap(result);
    } else {
      setDataProductMap([]);
    }
  };

  useEffect(() => {
    if (searchItem.length > 3) {
      fetchDataProduct();
    } else {
      setDataProductMap([]);
    }
  }, [searchItem]);

  return (
    <Box w={"40vw"} maw={700} mt={10}>
      <Menu opened={opened} onChange={setOpened} keepMounted>
        <Menu.Target>
          <TextInput
            placeholder="Nhập mã sản phẩm"
            rightSection={<IconSearch size={16} />}
            value={searchItem}
            onChange={(e) => setSearchItem(e.currentTarget.value)}
          />
        </Menu.Target>
        <Menu.Dropdown>
          <Table.ScrollContainer mah={450} minWidth={680} type="native">
            <Table striped withTableBorder w={680}>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Chọn</Table.Th>
                  <Table.Th>Mã sản phẩm</Table.Th>
                  <Table.Th>Tên sản phẩm</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {dataProductMap?.length > 0 ? (
                  dataProductMap?.map((item) => (
                    <Table.Tr>
                      <Table.Td>
                        <Button
                          onClick={() => {
                            setDataProductView((prev: any) => [
                              ...prev,
                              {
                                itemCode: item.itemCode,
                                itemName: item.itemName,
                              },
                            ]);
                          }}
                          disabled={dataProductView.some(
                            (i) => i.itemCode === item.itemCode
                          )}
                        >
                          Chọn
                        </Button>
                      </Table.Td>
                      <Table.Td fw={500} w={100}>
                        {item.itemCode}
                      </Table.Td>
                      <Table.Td fw={500}>{item.itemName}</Table.Td>
                    </Table.Tr>
                  ))
                ) : (
                  <Table.Tr>
                    <Table.Td colSpan={3} ta={"center"} fw={500}>
                      Không tìm thấy sản phẩm !
                    </Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
          <Flex justify={"center"} align={"center"} mt={10}>
            <Button
              color="red"
              // leftSection={<IconX size={16} />}
              w={"100%"}
              onClick={() => setOpened(false)}
            >
              Đóng
            </Button>
          </Flex>
        </Menu.Dropdown>
      </Menu>
      <Table striped highlightOnHover withTableBorder withColumnBorders mt={10}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Mã sản phẩm</Table.Th>
            <Table.Th>Tên sản phẩm</Table.Th>
            <Table.Th>Thao tác</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {dataProductView?.length > 0 ? (
            dataProductView?.map((item) => (
              <Table.Tr>
                <Table.Td fw={500} w={100}>
                  {item.itemCode}
                </Table.Td>
                <Table.Td fw={500}>{item.itemName}</Table.Td>
                <Table.Td>
                  <Button
                    color="red"
                    onClick={() => {
                      handleDeleteItem(item.itemCode);
                    }}
                  >
                    Xóa
                  </Button>
                </Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={3} ta={"center"} fw={500}>
                Bạn chưa chọn sản phẩm nào !
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
      <Flex justify={"end"} mt={10}>
        <Button
          color="teal"
          leftSection={<IconCheck size={16} />}
          onClick={() =>
            onSuccess(dataProductView?.map((item) => item.itemCode))
          }
        >
          Đồng bộ các sản phẩm đã chọn
        </Button>
      </Flex>
    </Box>
  );
};

export default ModalsSyncRockBottomPriceList;
